/* ============
 * Actions for the panoramas module
 * ============
 *
 * The actions that are available on the
 * panoramas module.
 */

import axios from 'axios';
import { apiEndpointConst, authHeader } from '@/utils/urls';
import * as types from './mutation-types';
import { production } from '../../environment';
import { generateInit } from '@/store/utils';

export default {
  load,
  getUnitsByPanoramaId,
  init: generateInit('panoramas'),
};

// ////////////////////////////////////////////
function apiEndpoint(order) {
  return production
    ? apiEndpointConst(order, 'panorama_global', '')
    : `/api-proxy/${order}/data/panorama_global`;
}

export function load({ commit }, { order }) {
  return axios
    .get(apiEndpoint(order), { headers: authHeader })
    .then((res) => {
      commit(types.LOAD, res.data);
      return res.data;
    });
}

export function getUnitsByPanoramaId({
  state,
  getters,
  rootState,
  rootGetters,
  commit,
  dispatch,
}, { order, panorama: id }) {
  return Promise.all([
    dispatch('units/init', { order }, { root: true }),
    dispatch('unitTypes/init', { order }, { root: true }),
  ])
    .then(([, unitTypes]) =>
      Promise.all(unitTypes.map(({ unit_type_id }) => dispatch('unitTypes/loadPanorama', {
        unitTypeId: unit_type_id,
      }, { root: true }))), )
    .then(() => {
      const { [id]: panorama } = Object
        .values(rootState.unitTypes.typePanoramas)
        .reduce(
          (res, panoramas) =>
            panoramas.reduce(
              (res, panorama) =>
                Object.assign(res, { [panorama.id]: panorama }),
              res,
            ),
          {},
        );

      return rootGetters['units/units'].filter(({ unit_type_id }) =>
        unit_type_id === panorama.unit_type_id, );
    }, );
}
